import { gql } from '@apollo/client/core'
import { FREE_ANSWER_FRAGMENT, PAGINATION_FRAGMENT } from '../Fragments'
import { FreeAnswer } from 'types/freeAnswer'

export interface FreeAnswersDataType {
  freeAnswers: {
    freeAnswers: FreeAnswer[]
    pagination: { page: number; pageLength: number; total: number }
  }
}

export const FREE_ANSWERS = gql`
  query freeAnswers($pagination: PaginationInput!, $filters: [FilterInput!]) {
    freeAnswers(pagination: $pagination, filters: $filters) {
      freeAnswers {
        ...FreeAnswerFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${FREE_ANSWER_FRAGMENT}
  ${PAGINATION_FRAGMENT}
`

export const LAST_SUBMITS = gql`
  query lastSubmits($pagination: PaginationInput!, $filters: [FilterInput!]) {
    lastSubmits(pagination: $pagination, filters: $filters) {
      freeAnswers {
        id
        addressId
        addressName
        forwardedAt
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${PAGINATION_FRAGMENT}
`
